import {
  ADD_QUOTE,
  REMOVE_QUOTE,
  SET_QUOTES,
  UPDATE_QUOTE,
} from '../actionTypes';
import {IFarmInputQuote} from 'constants/interfaces';

export type QuoteState = {lastUpdate: number; quotes: IFarmInputQuote[]};
const initialState: QuoteState = {lastUpdate: 0, quotes: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_QUOTES: {
      const quotes: IFarmInputQuote[] = action.payload || [];
      const stateUpdate: QuoteState = {
        lastUpdate: new Date().getTime(),
        quotes: quotes.map((depot) => ({...depot})),
      };
      return stateUpdate;
    }

    case UPDATE_QUOTE: {
      const quoteUpdate: IFarmInputQuote = action.payload;
      if (!quoteUpdate) return state;

      const stateUpdate: QuoteState = {
        lastUpdate: state.lastUpdate,
        quotes: state.quotes.map((quote) => {
          if (quote.id === quoteUpdate.id) return {...quoteUpdate};
          return quote;
        }),
      };
      return stateUpdate;
    }

    case REMOVE_QUOTE: {
      const quoteToRemoveId: string = action.payload;
      if (!quoteToRemoveId) return state;

      const stateUpdate: QuoteState = {
        lastUpdate: state.lastUpdate,
        quotes: state.quotes.filter((quote) => {
          return quote.id.toString() !== quoteToRemoveId;
        }),
      };
      return stateUpdate;
    }

    case ADD_QUOTE: {
      const quote: IFarmInputQuote = action.payload;
      if (!quote) return state;
      const stateUpdate: QuoteState = {
        lastUpdate: state.lastUpdate,
        quotes: [quote, ...state.quotes],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
